<!-- 水产养殖场详情 -->
<template>
  <div class="dialog-aquatic">
    <div class="header">
      <div class="title f-size-24 f-col-white08">{{ data.mc || '-' }}</div>
    </div>
    <div class="body">
      <div class="left">
        <div class="header">
          <div class="title">基础信息:</div>
        </div>
        <div class="content">
          <div class="descriptions-item">
            <span class="key">负责人：</span>
            <span class="value">{{ data.fzr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">养殖场名称：</span>
            <span class="value">{{ data.mc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所属镇街：</span>
            <span class="value">{{ data.szcj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系方式：</span>
            <span class="value">{{ data.lxfs || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">详细地址：</span>
            <span class="value">{{ data.dz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">受纳水体：</span>
            <span class="value">{{ data.snst || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="header">
          <div class="title">饲养情况:</div>
        </div>
        <div class="content">
          <div class="descriptions-item">
            <span class="key">类 别：</span>
            <span class="value">{{ data.lb || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">养 殖 类 型：</span>
            <span class="value">{{ data.yzlx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">养 殖 种 类：</span>
            <span class="value">{{ data.yzzl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">养殖面积（亩）：</span>
            <span class="value">{{ data.yzmj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">年生产能力（吨）：</span>
            <span class="value">{{ data.nscnl || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
console.log('data', data.value)
</script>

<style lang="scss" scoped>
.dialog-aquatic {
  width: 70.7rem;
  min-width: 70.7rem;
  .header {
    text-align: left;
    margin-bottom: 2rem;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    > div {
      min-width: 25.35rem;
    }
    .left {
      .key {
        width: 8.4rem;
        min-width: 8.4rem;
        text-align-last: justify;
      }
    }
    .right {
      .key {
        width: 12.6rem;
        min-width: 12.6rem;
        text-align-last: justify;
      }
    }
    .header {
      display: flex;
      margin-bottom: 0;
      justify-content: flex-start;
      margin-bottom: 1rem;
      .title {
        color: #fff;
        font-size: 1.4rem;
        height: 1.85rem;
        line-height: 1.85rem;
        margin-right: 1rem;
        &::before {
          content: '';
          border: 0.05rem solid #8ec0ce;
          width: 0.2rem;
          height: 0.8rem;
          box-sizing: border-box;
          margin-right: 0.4rem;
          display: inline-block;
        }
      }
    }
    .content {
      margin-bottom: 2rem;
      .descriptions-item {
        width: 100%;
        line-height: 2.65rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: flex-end;
        text-align: left;
        align-items: baseline;
        &:last-of-type {
          margin-bottom: 1.4rem;
        }
        .key {
          color: #fff;
          //   width: 9.8rem;
          min-width: 8.3rem;
          margin-right: 1.9rem;
          text-align: left;
        }
      }
    }
  }
}
</style>
